import React, { Fragment, memo, useCallback, useMemo } from "react";
import "./HawkeyeV2CreateFilterPanel.scss";
import Icon from "../Icons/Icon";
import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import pluralize from "pluralize";
import AxiomSpinner from "__AxiomComponents/AxiomUI/AxiomSpinner/AxiomSpinner";
import HawkeyeV2FilterSelection from "../HawkeyeV2FilterSelection/HawkeyeV2FilterSelection";
import { getSelectedFilters } from "../HawkeyeV2Filters/HawkeyeV2FilterUtils";

function FilterPanelOptions(props) {
  const {
    filterOptions,
    onSelection,
    isFetchingValues,
    filterValues,
    onFilterValueSelection,
    selectedFilters,
    editingFilter,
    selectedFilter,
  } = props;
  const [state, dispatch] = useAxiomState(
    {
      selectedFilterValue: [],
    },
    props.appName,
    props.appID,
    "FilterPanelOptions",
    props.componentID
  );

  const onCheckBoxClick = useCallback(
    (selectedFilterValue) => {
      const filterValues = selectedFilterValue.map((value) => value.displayName);
      const newSelectedFilters = getSelectedFilters(selectedFilters, selectedFilter, filterValues);

      if (onFilterValueSelection != null && typeof onFilterValueSelection == "function") {
        onFilterValueSelection(selectedFilterValue);
      }
      dispatch({
        selectedFilterLabel: null,
        selectedFilterValue: newSelectedFilters,
      });
    },
    [dispatch, selectedFilter, onFilterValueSelection, selectedFilters]
  );

  const onExpandOptions = useCallback(
    (e, selectedFilterLabel) => {
      e.preventDefault();
      let selectedFilterValue = [];
      if (
        editingFilter != null &&
        editingFilter.filterSettings != null &&
        editingFilter.filterSettings.length > 0
      ) {
        editingFilter.filterSettings
          .filter((d) => d.filter.displayName == selectedFilterLabel.displayName)
          .forEach((data) => {
            data.values.forEach((d) => {
              selectedFilterValue.push({
                key: d,
                displayName: d,
              });
            });
          });
      }
      if (
        state.selectedFilterLabel != null &&
        state.selectedFilterLabel.displayName == selectedFilterLabel.displayName
      ) {
        dispatch({
          selectedFilterLabel: null,
          selectedFilterValue: selectedFilterValue,
        });
      } else {
        dispatch({
          selectedFilterLabel: selectedFilterLabel,
          selectedFilterValue: selectedFilterValue,
        });
        if (onSelection != null && typeof onSelection == "function") {
          onSelection(selectedFilterLabel);
        }
      }
    },
    [dispatch, onSelection, state.selectedFilterLabel, editingFilter]
  );
  const renderSymbol = useCallback(
    (index, displayName, selectionFunction, key, isSelected, component) => {
      return (
        <Fragment>
          <div key={`option_value_${index}`} className="check-box-label">
            <div className="check-box">
              <input
                type="checkbox"
                key={`image-filter-checkbox_${index}`}
                className="image-filter-checkbox"
                id={`image-filter-checkbox_${index}`}
                checked={isSelected}
                onChange={selectionFunction}
              ></input>
              <label htmlFor={`image-filter-checkbox_${index}`}></label>
            </div>
            <div className="value-label">{displayName}</div>
          </div>
        </Fragment>
      );
    },
    []
  );
  const filterData = useMemo(() => {
    const filterOptionsData = [...filterOptions];
    const selectedFiltersData = {};
    selectedFilters.forEach((d) => {
      selectedFiltersData[`'${d.filter.displayName}'`] = d;
    });
    const selectedFilterValue = state.selectedFilterValue.map((d) => d.displayName);
    filterOptionsData.forEach((data) => {
      if (selectedFiltersData.hasOwnProperty(`'${data.displayName}'`) == true) {
        data.filterValues = selectedFiltersData[`'${data.displayName}'`].values.map((d) => {
          return {
            displayName: d,
            isSelected: true,
          };
        });
      }
      if (
        state.selectedFilterLabel != null &&
        data.displayName == state.selectedFilterLabel.displayName
      ) {
        data.isExpand = true;
        data.filterValues = filterValues.map((d) => {
          d.isSelected =
            selectedFilterValue.indexOf(d.displayName) != -1 ||
            (selectedFiltersData[`'${data.displayName}'`] != null &&
              selectedFiltersData[`'${data.displayName}'`].values.indexOf(d.displayName) != -1);
          return d;
        });
      } else {
        data.isExpand = false;
      }
    });
    return filterOptionsData;
  }, [
    filterOptions,
    state.selectedFilterLabel,
    filterValues,
    state.selectedFilterValue,
    selectedFilters,
  ]);

  return (
    <div className="filter-panel-options">
      {filterData.map((data, indexOuter) => {
        const selectedValues =
          data.filterValues != null
            ? data.filterValues.filter((d) => {
                return d.isSelected;
              })
            : [];
        return (
          <div key={`filter_option_${indexOuter}`} className="filter-label-with-values">
            <div className="filter-option-label">{data.displayName}</div>
            <div
              className="filter-values-icons"
              onClick={(e) => {
                onExpandOptions(e, data);
              }}
            >
              <div className="search-icon-filter-panel">
                <Icon icon="ICON_SEARCH" className="hawkeye-search-tag-icon" />
              </div>
              <div className="expand-all-label">
                {selectedValues.length > 0
                  ? selectedValues.map((d) => d.displayName).join(",")
                  : `All ${pluralize(data.displayName, 2)}`}
              </div>
              <Icon icon="ICON_EXPAND_DOWN" className="hawkeye-down-tag-icon" />
            </div>
            {data.isExpand == true && (
              <HawkeyeV2FilterSelection
                isFetchingValues={isFetchingValues}
                filterValues={data.filterValues}
                selectedFilter={selectedFilter}
                selectedValues={selectedValues}
                onSelection={onCheckBoxClick}
                appName={props.appName}
                appID={props.appID}
                componentID={`selection-value-${props.componentID}`}
                renderSymbol={renderSymbol}
              />
            )}
            {selectedValues.length > 0 && (
              <div className="circle-with-label">
                <Icon icon="ICON_CIRCLE_WITH_CHECK" className="hawkeye-circle-checked-tag-icon" />
                <div className="">
                  {" "}
                  {`${selectedValues.length} ${pluralize("value", selectedValues.length)} selected`}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
export default memo(FilterPanelOptions);
